import { useSelector } from "react-redux";
import type { RootState } from "@src/reducers/store";

export const useIsTTNamespace = (): boolean => {
  const namespace = useSelector(
    (state: RootState) => state.yourSlice.authContext?.customerNamespace,
  );
  if (namespace) {
    return namespace === "286bf028-3f4b-432d-a9dc-7c31dd464dc4";
  }
  return false;
};
